import React from "react";

import { HeaderContainer } from "./styled";
import CalConLogo from "../../../assets/othl/calcon-logo-white-2x.fa4e4317.png";
import HeaderBanner from "../../../assets/banner/header.jpg";

const Header = ({ backgroundImage, name }) => (
  <HeaderContainer
    // backgroundImage={backgroundImage}
    // id="nav-header"
    // role="banner"
    backgroundImage={HeaderBanner} // Using hardcoded image path instead
    id="nav-header"
    role="banner"
  >
    <a
      href="https://www.calconmutualmortgage.com//"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="calconmutualmortgage.com/"
    >
      <div className="bg-gradient-to-r from-gray-700/50 to-gray-700/50 md:from-gray-700/25 p-2 sm:p-0 h-full">
        <img
          src={CalConLogo}
          alt="CalCon Logo"
          style={{
            width: "280px",
            paddingTop: "25px",
            paddingLeft: "30px",
          }}
        />
      </div>
    </a>
    <h1>Specializing in Manufactured & Modular Home Financing</h1>
  </HeaderContainer>
);

export default Header;
